import React, { useState } from 'react';

import { useAuth } from '../../hooks/useAuth';
import { useConfig } from '../../hooks/useConfig';
import { achTesterEligible } from '../../util/apiHostFor';

// small contained component to temporarily allow for
// logout and escaping to legacy views
function ExtraPanel() {
  const { apiHost, achBackendEnabled, setAchBackendEnabled } = useConfig();
  const [isOpen, setIsOpen] = useState(false);
  const { logout, user } = useAuth();

  // Toggle offered only to allowlisted testers. UX scoping, not a security
  // boundary — ACH backend authz is the real gate.
  const canFlipAchBackend = achTesterEligible(user?.email, import.meta.env.VITE_ACH_TESTER_EMAILS);

  // convert OneDSP URLs to match legacy Ventura URLs
  const translatePathToLegacy = (pathname: string): string => {
    // catch foxused contract URLs
    const contractPageRegex = /\/admin\/contracts\/\d+/;
    if (pathname.match(contractPageRegex)) {
      return pathname.replace('/admin/contracts/', '/admin/#/contracts/');
    }

    // admin should always be converted to a hash route
    const mappedPaths = {
      '/admin/contracts': '/admin/#/contracts',
      '/admin/customsegments': '/admin#/custom_segments',
      '/admin/contracts/new': '/admin/#/contracts/new',
    };

    return mappedPaths[pathname] || '/admin/#/contracts';
  };

  // send user back to legacy Ventura-mapped URL
  const jumpBackToLegacy = () => {
    const convertedLocation = translatePathToLegacy(window.location.pathname);
    window.location.href = `${apiHost}${convertedLocation}`;
  };

  // log out user
  const logoutUser = async (e) => {
    e.preventDefault();
    logout(apiHost);
  };

  return (
    <>
      {/* Shown to allowlisted testers while ACH is ON. */}
      {canFlipAchBackend && achBackendEnabled ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10000,
            backgroundColor: '#b71c1c',
            color: '#fff',
            padding: '2px 14px',
            borderRadius: '0 0 6px 6px',
            fontSize: '12px',
            fontWeight: 700,
            letterSpacing: '0.5px',
          }}
        >
          ACH backend ACTIVE
        </div>
      ) : null}
      <div
        style={{
          position: 'fixed',
          display: 'inline',
          padding: `${isOpen ? '5px' : '0px'}`,
          right: '0',
          // 110 + the collapse-btn's 30px offset lands the arrow below the chat
          // drawer's header row (its close button sits ~y100), above DebugView (200).
          top: '110px',
          backgroundColor: 'white',
          border: `${isOpen ? '1px solid black' : 'none'}`,
          borderRadius: '5px 5px 5px 5px',
          width: `${isOpen ? '250px' : '0px'}`,
          // marginRight: `${isOpen ? '0px' : '-250px'}`,
          zIndex: '9999',
          textAlign: 'center',
          lineHeight: '23px',
        }}
      >
        {isOpen ? (
          <div className="contents" style={{ display: 'inline-block', margin: '5px auto' }}>
            <button type="button" onClick={(e) => logoutUser(e)}>
              Logout
            </button>
            <br />
            <br />
            <button type="button" onClick={() => jumpBackToLegacy()}>
              Take me back to Ventura!
            </button>
            {canFlipAchBackend ? (
              <>
                <br />
                <br />
                <button type="button" onClick={() => setAchBackendEnabled(!achBackendEnabled)}>
                  ACH backend: {achBackendEnabled ? 'ON' : 'OFF'}
                </button>
              </>
            ) : null}
          </div>
        ) : null}
        <button
          className="collapse-btn"
          type="button"
          style={{
            position: 'absolute',
            top: '30px',
            left: '-30px',
            height: '30px',
            backgroundColor: 'white',
            borderLeft: '1px solid black',
            borderTop: '1px solid black',
            borderRight: '0',
            borderBottom: '1px solid black',
            borderRadius: '5px 0px 0px 5px',
          }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span
            style={{
              fontSize: '1.5em',
            }}
          >
            {isOpen ? '▶' : '◀'}
          </span>
        </button>
      </div>
    </>
  );
}

export default ExtraPanel;
